import { jsx as t } from "react/jsx-runtime";
import { Progress as e } from "@chakra-ui/react";
import "react";
import { combineClasses as i } from "../../../utils/combineClasses.mjs";
import "react-nanny";
const _ = ({
  className: r,
  size: m = "md",
  value: o = 0,
  variant: s = "normal",
  ...p
}) => (s === "error" && o === 0 && (r = i("gravity-progress__appear-full", r)), /* @__PURE__ */ t(e, { size: m, value: o, variant: s, className: r, ...p }));
export {
  _ as Progress
};
